export default __webpack_public_path__ + "static/media/bg.82c83b96.png";